/*
Function that will call the configured Elevation API based on the Variable: __ELEVATION_API__
__ELEVATION_API__: GOOGLE | OPEN_ELEVATION | API | undefined
If value is GOOGLE or undefined the API will use the elevation service from Google, if the value is OPEN_ELEVATION
the function will use the Open Elevation service from: https://github.com/Jorl17/open-elevation/blob/master/docs/api.md
*/

import { getOpenElevationForLocations } from './openElevation-API'
import { fetchElevation } from '../../action/elevation-actions'

import { store } from '../store'

export const getElevationForLocations = locations => {
  return new Promise((resolve, reject) => {
    const elevationAPI = __ELEVATION_API__ ? __ELEVATION_API__ : ''

    switch (elevationAPI) {
      case 'OPEN_ELEVATION':
        let openLocations = locations
        getOpenElevationForLocations(openLocations, (results, error) => {
          if (error) {
            let elevation = new google.maps.ElevationService()
            elevation.getElevationForLocations(
              {
                locations: locations
              },
              (results, status) => {
                if (status != 'OK') {
                  // when the status is not ok sometimes an error_message field can come on the results object
                  let errorMessage = `Error accessing the Google Elevation service, ${results && results[0] ? results[0].error_message : ''
                    }. Status: ${status}`
                  reject(errorMessage)
                } else {
                  resolve(results)
                }
              }
            )
          } else {
            resolve(results)
          }
        })
        break
      case 'API':
        let results = []
        locations.map(item => {
          let { lng, lat } = item
          if (typeof lng == 'function') {
            lng = lng()
          }

          if (typeof lat == 'function') {
            lat = lat()
          }

          store
            .dispatch(fetchElevation(lng, lat))
            .then(res => {
              results.push({ elevation: res })
              if (results.length === locations.length) {
                resolve(results)
              }
            })
            .catch(err => {
              let elevation = new google.maps.ElevationService()
              elevation.getElevationForLocations(
                {
                  locations: locations
                },
                (results, status) => {
                  if (status != 'OK') {
                    // when the status is not ok sometimes an error_message field can come on the results object
                    let errorMessage = `Error accessing the Google Elevation service, ${results && results[0] ? results[0].error_message : ''
                      }. Status: ${status}`
                    reject(errorMessage)
                  } else {
                    resolve(results)
                  }
                }
              )
            })
        })
        break
      case 'GOOGLE':
      default:
        let elevation = new google.maps.ElevationService()
        elevation.getElevationForLocations(
          {
            locations: locations
          },
          (results, status) => {
            if (status != 'OK') {
              // when the status is not ok sometimes an error_message field can come on the results object
              let errorMessage = `Error accessing the Google Elevation service, ${results && results[0] ? results[0].error_message : ''
                }. Status: ${status}`

              reject(errorMessage)
            } else {
              resolve(results)
            }
          }
        )
        break
    }
  })
}
